<template>
  <div class="px-3">
    <div class="relative my-3">
      <!-- <span class="absolute bg-transparent right-0 mt-2 mr-3 text-green-500 text-xs font-bold text-shadow">{{ dailyChange.toFixed(2) }}%</span> -->
      <div class="bg-white hover:shadow border w-full rounded-md overflow-hidden">
        <div class="pt-3 px-3">
          <div class="flex justify-between">
            <img ref="logoRef" loading="lazy" :src="`/logos/${id}.png`" class="w-6 h-6 self-center" />
            <h1 class="text-xl font-bold">
              {{ name }}
            </h1>
            <div
              class="text-xs font-bold text-shadow self-center"
              :class="{
                'text-red-500': String(dailyChange).startsWith('-'),
                'text-green-500': !String(dailyChange).startsWith('-')
              }"
            >
              {{  dailyChange.toFixed(2) }}% <span class="text-black font-thin">24h</span>
            </div>
          </div>
          <div class="flex flex-col">
            <div class="text-sm flex justify-between mt-2">
              <span>Price</span>
              {{ formatCurrency(price) }}
            </div>
            <div class="text-sm flex justify-between mt-2">
              <span>Market Cap</span>
              {{ formatCurrency(marketCap) }}
            </div>
            <div class="text-sm flex justify-between mt-2">
              <span>24h Volume</span>
              {{ formatCurrency(dailyVolume) }}
            </div>
          </div>
        </div>
        <CryptoCardControls v-if="messagingSupported" :id="id" :notificationOn="this.priceNotifications.includes(id)" @notification-click="toggleAlert" class="absolute bottom-0 right-0 m-1" />
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" class="-mb-6" v-if="averageLogoColor">
          <path :fill="averageLogoColor" fill-opacity="1" d="M0,128L60,112C120,96,240,64,360,74.7C480,85,600,139,720,154.7C840,171,960,149,1080,128C1200,107,1320,85,1380,74.7L1440,64L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import FastAverageColor from 'fast-average-color';
import CryptoCardControls from './CryptoCardControls';
import { mapGetters } from "vuex";

export default {
  name: "CryptoCard",
  props: {
    id: Number,
    fill: String,
    name: String,
    symbol: String,
    price: Number,
    dailyVolume: Number,
    dailyChange: Number,
    marketCap: Number,
  },
  components: {
    CryptoCardControls,
  },
  data() {
    return {
      averageLogoColor: undefined,
      priceNotifications: [],
      messagingSupported: Boolean(this.$messaging),
    }
  },
  mounted() {
    this.getLogoColor()

    if (this.isLoggedIn) {
      this.$firestore.collection("users").doc(this.firebaseUid).get()
        .then((querySnapshot) => {
          const userData = querySnapshot.data()
          this.priceNotifications = userData.priceNotifications
        })
        .catch(function(error) {
          console.error("Error writing document: ", error);
        });
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'firebaseUid'])
  },
  methods: {
    toggleAlert() {
      if (this.priceNotifications.includes(this.id)) {
        this.priceNotifications = this.priceNotifications.filter((id) => id !== this.id)
      } else {
        this.priceNotifications.push(this.id)
      }

      this.getMessagingToken()

      const priceNotifications = this.priceNotifications.includes(this.id) ? this.$firebase.firestore.FieldValue.arrayUnion(this.id) : this.$firebase.firestore.FieldValue.arrayRemove(this.id)
        this.$firestore.collection("users").doc(this.firebaseUid).update({ priceNotifications })
        .then(function() {
            console.log("Document successfully written!");
        })
        .catch(function(error) {
            console.error("Error writing document: ", error);
        });
    },
    async getMessagingToken() {
      await this.$messaging.requestPermission()
      // Get Instance ID token. Initially this makes a network call, once retrieved
      // subsequent calls to getToken will return from cache.
      this.$messaging.getToken().then((currentToken) => {
        if (currentToken) {
          console.log(currentToken)
          // sendTokenToServer(currentToken);
          // updateUIForPushEnabled(currentToken);

          this.$firestore.collection("users").doc(this.firebaseUid).update({ notificationToken: currentToken })

        } else {
          // Show permission request.
          // console.log('No Instance ID token available. Request permission to generate one.');
          // // Show permission UI.
          // updateUIForPushPermissionRequired();
          // setTokenSentToServer(false);
        }
      }).catch((err) => {
        console.error(err)
        // console.log('An error occurred while retrieving token. ', err);
        // showToken('Error retrieving Instance ID token. ', err);
        // setTokenSentToServer(false);
      });

      // messaging.onTokenRefresh(() => {
      //   messaging.getToken().then((refreshedToken) => {
      //     console.log('Token refreshed.');
      //     // Indicate that the new Instance ID token has not yet been sent to the
      //     // app server.
      //     setTokenSentToServer(false);
      //     // Send Instance ID token to app server.
      //     sendTokenToServer(refreshedToken);
      //     // ...
      //   }).catch((err) => {
      //     console.log('Unable to retrieve refreshed token ', err);
      //     showToken('Unable to retrieve refreshed token ', err);
      //   });
      // });
    },
    getWaveColor() {
      return '#'+Math.floor(Math.random()*16777215).toString(16)
    },
    downloadImage() {
    },
    async getLogoColor() {
      const fac = new FastAverageColor();
      const color = await fac.getColorAsync(this.$refs.logoRef)

      this.averageLogoColor = color.rgba
    },
    formatCurrency(price) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });

      return formatter.format(price);
    }
  }
};
</script>